import { RootState } from '../rootReducer'

export const selectContextMenuData = (state: RootState) => state.global.contextMenuData

export const selectPageLimit = (name: string) => (state: RootState) => state.global.pageLimits[name]

export const selectSort = (name: string) => (state: RootState) => state.global.sorts[name]

export const selectFilter = (name: string) => (state: RootState) => state.global.filters[name]

export const selectVariant = (name: string) => (state: RootState) => state.global.variants[name]

export const selectMobileMenuOpen = (state: RootState) => state.global.mobileMenuOpen

export const selectReloadFlag = (state: RootState) => state.global.reloadFlag

export const selectActiveSection = (state: RootState) => state.global.activeSection
